<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/colors";

  label {
    display: flex;
    align-items: center;
    gap: utils.in_rem(10px);
    &.align-top {
      align-items: flex-start;
    }

    &.left {
      flex-direction: row;
    }
    &.right {
      flex-direction: row-reverse;
    }

    .toggle-wrapper {
      display: flex;
      align-items: center;
      &.padding-top {
        padding-top: utils.in_rem(0.5px);
      }
    }

    .text {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);

      .text-label {
        display: flex;
        align-items: center;
        gap: utils.in_rem(4px);
        color: colors.get(textBlack);
        @include mixins.body2();
      }

      .description {
        color: colors.get(textGrey);
        @include mixins.caption();
      }
    }
  }
</style>

<script>
  // Components
  import IconScale from "../IconScale.svelte";
  import Toggle from "./Toggle.svelte";

  export let checked;
  export let disabled = false;
  export let label = "";
  export let tooltip = false; // Bool to decide if the slot should show or not
  export let selector = "left"; // place toggle left or right of text.
  export let onToggle = () => {}; // Callback for when the toggle changes
</script>

<label class="text-toggle {selector}" class:align-top={$$slots.description}>
  <div class="toggle-wrapper" class:padding-top={$$slots.description}>
    <Toggle bind:checked {disabled} onChange={onToggle} />
  </div>
  <div class="text">
    <div class="text-label">
      {label}
      <!-- Slot allows for custom span styling -->
      {#if $$slots.tooltip && tooltip}
        <IconScale class="fa-circle-info" size="xs" placement="top">
          <span slot="tooltip"><slot name="tooltip" /></span>
        </IconScale>
      {/if}
    </div>
    {#if $$slots.description}
      <span class="description">
        <slot name="description" />
      </span>
    {/if}
  </div>
</label>
